// extracted by mini-css-extract-plugin
export default {"container":"UserLoginSSO_container__buWPR","sign-in":"UserLoginSSO_sign-in__C4g0V","text":"UserLoginSSO_text__MFbuE","button":"UserLoginSSO_button__t-vM1"};